@if (meeting.videoUrl !== null) {
  <app-video-player [meeting]="meeting" (jumpToNextSpeaker)="jumpToNextSpeaker($event)" (updateMediaTime)="updateMediaTimeQueryParameter()"></app-video-player>
} @else if (meeting.audioUrl !== null) {
  <app-audio-player [meeting]="meeting" (jumpToNextSpeaker)="jumpToNextSpeaker($event)" (updateMediaTime)="updateMediaTimeQueryParameter()"></app-audio-player>
}
